import styled from 'styled-components/native';

import { Body1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

export const Text = styled(Body1)`
  text-align: center;
  padding: ${padding}px;
`;
